export function isValid(value: any): boolean {
  return value !== undefined && value !== null && value !== "";
}

const toString = Object.prototype.toString;

export const is = (val: unknown, type: string) => {
  return toString.call(val) === `[object ${type}]`;
};

export const isString = (val: unknown): val is string => {
  return is(val, "String");
};

export const deepEqual = (arr1, arr2) => {
  return JSON.stringify(arr1) === JSON.stringify(arr2);
};

export const deepClone = (obj) => JSON.parse(JSON.stringify(obj));

/**
 * 获取指定 ID 的所有父级 ID
 * @param {Array} data - 多维数组
 * @param {string|number} targetId - 目标 ID
 * @returns {Array} - 父 ID 集合数组
 */
export const findParentIds = (data, targetId) => {
  const result = [];

  /**
   * 内部递归函数
   * @param {Array} nodes - 当前层级的数组
   * @param {Array} path - 当前路径上的父 ID
   * @returns {boolean} - 是否找到目标 ID
   */
  function traverse(nodes, path) {
    for (const node of nodes) {
      // 将当前节点的 ID 加入路径
      const currentPath = [...path, node.id];
      // 如果找到目标 ID，保存路径并返回
      if (String(node.id) === targetId) {
        result.push(...path);
        return true;
      }

      // 如果有子节点，递归查找
      if (node.children && Array.isArray(node.children)) {
        if (traverse(node.children, currentPath)) {
          return true; // 如果目标 ID 已找到，停止进一步递归
        }
      }
    }
    return false; // 当前层级未找到目标 ID
  }

  traverse(data, []);
  return result;
};

// 判断是否为base64图片;
export function isBase64Image(str: string) {
  return /^data:image\/(png|jpeg|jpg|gif);base64,/.test(str);
}

/** 是否gif图片 */
import { getFileExtension } from "~/utils/file";
export function isGif(name: string): boolean {
  return getFileExtension(name) === "gif";
}
